import Cookies from 'js-cookie';

import {
  getSsoCookieNames,
  LEGACY_COOKIE_NAMES,
  SSO_COOKIE_DOMAIN,
} from './constants';

export interface SsoCookieTokens {
  refreshToken?: string;
  accessToken?: string;
  idToken?: string;
}

export const readSsoCookies = (
  apiEnv: string | undefined | null
): SsoCookieTokens => {
  const names = getSsoCookieNames(apiEnv);

  return {
    refreshToken: Cookies.get(names.REFRESH_TOKEN),
    accessToken: Cookies.get(names.ACCESS_TOKEN),
    idToken: Cookies.get(names.ID_TOKEN),
  };
};

export const writeSsoCookies = (
  { refreshToken, accessToken, idToken }: SsoCookieTokens,
  apiEnv: string | undefined | null
): void => {
  const names = getSsoCookieNames(apiEnv);
  const options = { domain: SSO_COOKIE_DOMAIN };

  if (refreshToken) {
    Cookies.set(names.REFRESH_TOKEN, refreshToken, options);
  }

  if (idToken) {
    Cookies.set(names.ID_TOKEN, idToken, options);
  }

  if (accessToken) {
    Cookies.set(names.ACCESS_TOKEN, accessToken, options);
  }
};

const removeCookie = (name: string) => {
  Cookies.remove(name, { domain: SSO_COOKIE_DOMAIN });
};

/**
 * Clears this environment's SSO cookies.
 * Also removes legacy unscoped names so pre-isolation cookies do not linger.
 */
export const clearSsoCookies = (apiEnv: string | undefined | null) => {
  const names = getSsoCookieNames(apiEnv);

  removeCookie(names.ID_TOKEN);
  removeCookie(names.ACCESS_TOKEN);
  removeCookie(names.REFRESH_TOKEN);

  removeCookie(LEGACY_COOKIE_NAMES.ID_TOKEN);
  removeCookie(LEGACY_COOKIE_NAMES.ACCESS_TOKEN);
  removeCookie(LEGACY_COOKIE_NAMES.REFRESH_TOKEN);
};
